export default "__VITE_ASSET__C5N7I6sN__"